import { Component, OnInit ,Output,EventEmitter ,Injectable} from '@angular/core';
 
import { LoginService} from '../../../login/login.service';

import { UpdateNotificationService} from 'app/layout/notifications-page/update-notification.service'
;

import {Notification} from 'app/layout/notifications-page/notification';

    import { from } from 'rxjs/observable/from';

    import { Router }            from '@angular/router';
import { Http ,RequestOptions}       from '@angular/http';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { routerTransition } from '../../../router.animations';
 

 import {Headers} from '@angular/http';
// Observable class extensions
import 'rxjs/add/observable/of';
 
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/toPromise';
 import { URLSearchParams } from '@angular/http'; 
//import { Migration } from './migration';
import { LayoutService} from '../../../layout/layout.service';


import { ALLOW_MULTIPLE_PLATFORMS } from '@angular/core/src/application_ref';




import { environment } from 'environments/environment';

@Injectable()

export class NotificationsService implements OnInit {


    @Output () public notificationsUpdateEvent = new EventEmitter <any>();

name: string ;
agent:  any ;
hasNotifications:boolean =false;

notificationCount:number=0;
ticketCount:number=0;

notificationURL:string =environment.apiRoot+'UpdateNotificationRead';
 
data:any ={};
private headers = new Headers({'Content-Type': 'application/json'});


 
notificationsCount: Array<number>;


notificationsMap  : Map <number,string >;
 NotificationStringToIntValMap : Map <string,number >;

notificationTypeMap : Map <number, Array <Notification>>;


    constructor(private loginService:  LoginService,  private layoutService: LayoutService,  public notificationService: UpdateNotificationService , private http:Http ) {
     
       
        this.notificationsCount = new Array <number>(5);
     

        this.notificationsMap = new Map <number, string>();
        this.NotificationStringToIntValMap = new Map <string, number>();
        this.notificationTypeMap = new Map <number, Array <Notification>>();

        



        this.notificationsMap.set( Notification.ERROR,"ERROR" );
        this.notificationsMap.set( Notification.NEW_ORDER, "NEW_ORDER");
        this.notificationsMap.set( Notification.HELP_REQUEST,"HELP_REQUEST");
        this.notificationsMap.set( Notification.REMINDER,"REMINDER");


        console.log( "notification  map size " + this.notificationsMap.size );
        console.log( "value of notificationMap get" + this.notificationsMap.get(Notification.NEW_ORDER) );


        
var iterator = this.notificationsMap.keys();

        for ( var i=0; i<  this.notificationsMap.size; i++) {

            this.notificationTypeMap.set(  iterator.next().value, new Array <Notification>());
        
        }


        this.AddNotificationToMap( loginService.agent.notifications);


      this.loginService.profileUpdateEvent.subscribe ( data => this.updateNotifications (data));

    

    }


    AddNotificationToMap ( notifications:Array<any>) {
    
        
let notification:Notification;
this.notificationCount=0;



        for ( let i=0; i<  notifications.length; i++) {
            notification = notifications[i] as Notification;

            if ( !notification.notificationCleared) {
                this.notificationCount++;

                this.notificationsCount[notification.notificationType]++;
 
            }

           

        }



    }


    updateNotifications( agent: any) {


     

try {
        this.UpdateNotification( agent.notifications);

        this.notificationsUpdateEvent.emit();

      

    } catch  ( any) {}



    }

    UpdateNotification ( notifications: any) {


        console.log("Notification sizes "+notifications.length);
        

        // reset notifcation map

        var iterator = this.notificationsMap.keys();

        for ( var i=0; i< this.notificationsMap.size; i++) {

            this.notificationTypeMap.set( iterator.next().value , new Array <Notification>());

        }


        for ( var i=0; i< 5; i++) {
          
            this.notificationsCount[i]=0;
        
        }
      

let notification:Notification;
this.notificationCount=0;

 

        for ( let i=0; i<  notifications.length; i++) {
          
            notification = notifications[i] as Notification;

            if ( !notification.notificationCleared) {
              
                this.notificationCount++;

             
               var list = this.notificationTypeMap.get(notification.notificationType);
                
            
              
             if ( list!=null) {


             list.push(notification);

             this.notificationTypeMap.set( notification.notificationType, list);
 

            }


            }

           
        }


        
 

        if ( this.notificationCount>0) {
      
            this.hasNotifications=true;
        
            
        
          }


          console.log( " MAP SIZE " +this.notificationTypeMap.size);
          

    }

    ngOnInit() {


        
       
        this.UpdateNotification( this.loginService.agent.notifcations);
        

        this.loginService.profileUpdateEvent.subscribe( 

              agentData => {

                this.UpdateNotification( agentData.notifications);

             
                


            }


        );
 

 if ( this.loginService.agent.tickets.length>0 ||this.loginService.agent.notifications.length>0 ) {

    this.ticketCount= this.loginService.agent.tickets.length;

    let count=0;

    let notifies = this.loginService.agent.notifications;



    this.notificationsCount = new Array <number>(5);

    for ( var i=0; i< 5; i++) {
      
        this.notificationsCount[i]=0;

    
    }
  

    for (let i=0; i< notifies.length; i++ ) {

        if  ( !notifies[i].notificationCleared) {
            count++;
            this.notificationsCount[notifies.notificationType]++;
        }

       
    

  }


  this.notificationsCount[Notification.HELP_REQUEST] =  this.loginService.agent.tickets.length;
  
  



   

  if ( count>0) {
      
    this.hasNotifications=true;

    this.notificationCount=count;

  }

 }


    }
 

     

     

    GetStyle() {

        let isSemi =false;
        let transform =   'translateX(50%)';
    
        return {
            'bottom': '75%',
            'left': '75%',
            'transform': transform,
            '-moz-transform': transform,
            '-webkit-transform': transform,
            'font-size': 15 + 'px',
            
    };
}


 

GetNotificationStyle () {
if ( this.hasNotifications) {
    return {

        'color':'#ffffff'
        
    }
}
    return {};

}




UpdateNotificationToRead( read: boolean,  notificationId: string) : Promise<any>  { 
   
 

    
  
    let update = new NotificationUpdate ( this.loginService.agent.id, notificationId);
  
    return this.http.post(this.notificationURL, JSON.stringify( update) , {headers: this.headers} )
  .toPromise();
  
  
  
        }
      



UpdateAgentNotifications (notification: any) : Promise<any> {

    // update notifcation read state

    let promise = new Promise (  ( resolve, reject ) =>
    { 


        this.UpdateNotificationState (true,  notification.id).then ( 


          data => {
        
            for ( let i= 0; i< this.loginService.agent.notifications.length; i++) {
       
              if ( this.loginService.agent.notifications[i].id == notification.id)  {
               
                this.loginService.agent.notifications[i].notificationCleared=true;
             

              //  this.notificationsUpdateEvent.emit(-1);
                this.loginService.AgentProfileUpdated();
                

                break;
    
              }

              
            }
           

            // emit the change to subscribers;

            
              this.notificationsUpdateEvent.emit( this.loginService.agent.notifications);
          
          
            resolve(); // resolve promise

           
        }). catch ( error => reject());
    });

  return promise;

}


UpdateNotificationState( read: boolean,  notificationId: string) : Promise<any>  { 

 
let update = new NotificationUpdate ( this.loginService.agent.id, notificationId);

return this.http.post(this.notificationURL, JSON.stringify( update) , {headers: this.headers} )
.toPromise();


  }


}
export class NotificationUpdate {
  public notificationId: string;
  public id: string;
  
 constructor (idIn:string, notificationIdIn:string) {
    this.notificationId=notificationIdIn;
    this.id= idIn;

  }
}
 
 



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/shared/components/Notifications/notifications-service.ts